var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNhlShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NHL_Shield_En_Primary 1",
    clipPath: "url(#clip0_1187_138726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.14262 33.9106C3.14262 28.8233 5.52895 26.8888 6.01759 22.0693C5.34821 26.2931 2.54688 29.7538 2.54688 33.9106C2.54688 35.5071 2.76777 36.9663 3.16605 38.2883C4.92651 44.1387 10.1577 47.3952 15.2249 48.677C7.41993 46.7024 3.14262 40.1525 3.14262 33.9106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.2606 27.2369C45.3135 24.9343 44.2726 22.8558 44.2726 20.2988C44.2726 26.4906 47.2346 28.241 47.2346 33.9072C47.2346 40.1492 42.9573 46.699 35.1523 48.6737C42.1908 46.8931 47.7868 41.7389 47.7868 33.9072C47.7868 31.2532 47.0538 29.1681 46.2606 27.2369Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.2083 9.23741C43.6119 8.7655 42.4472 7.56062 41.751 5.6529L40.1345 1.22498L39.3848 4.02631C40.9176 10.9075 46.5806 11.4028 46.5806 11.4028L48.8799 10.3218L45.2117 9.24075L45.2083 9.23741Z",
    fill: "#D0D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.4903 34.2989L15.5283 29.7605L12.2383 32.2305C12.2383 32.2305 13.3896 32.264 13.3896 33.4688V42.0168L15.7123 40.273V34.2319L18.3597 38.285L20.813 36.4442V25.7944L18.4903 27.5382V34.3022V34.2989Z",
    fill: "#D0D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.9044 24.3988L25.2837 26.3667V22.4308L21.7461 25.0882C21.7461 25.0882 22.8974 25.1217 22.8974 26.3299V34.8745L25.2837 33.0839V29.1881L27.9044 27.2202V31.116L30.1769 29.409V18.7559L27.9044 20.4628V24.3988Z",
    fill: "#D0D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.5455 23.4114V15.4793L31.0078 18.1368C31.0078 18.1368 32.1591 18.1702 32.1591 19.3751V27.923L38.7458 22.9764C38.6052 21.2728 38.7458 20.2587 38.7458 20.2587L34.5455 23.4114Z",
    fill: "#D0D3D4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.4458 20.3122C4.4458 26.36 1.48047 27.5616 1.48047 33.9073C1.48047 35.8418 1.80846 37.6524 2.40086 39.3192C2.58494 38.9376 2.85938 38.5695 3.17064 38.285C2.77236 36.963 2.55147 35.5037 2.55147 33.9073C2.55147 29.7504 5.34946 26.2898 6.02218 22.066C6.07574 21.5171 6.1092 20.9314 6.1092 20.2988C6.1092 15.4726 3.80655 11.3961 3.80655 11.3961L1.50724 10.3151L3.06689 13.8561C3.85341 15.64 4.44915 17.8322 4.44915 20.3089L4.4458 20.3122Z",
    fill: "url(#paint0_linear_1187_138726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.2734 20.3022C44.2734 22.8592 45.3143 24.9376 46.2615 27.2403L47.4998 27.2001C46.7334 25.279 45.9368 23.4482 45.9368 20.3156C45.9368 17.8389 46.5326 15.6467 47.3191 13.8628L48.8787 10.3218L46.5794 11.4028C46.5794 11.4028 44.2768 15.4793 44.2768 20.3055L44.2734 20.3022Z",
    fill: "url(#paint1_linear_1187_138726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M23.3781 50.5312C21.4938 49.8518 18.9334 49.6141 15.2251 48.677C10.1579 47.3918 4.92673 44.1386 3.16627 38.2883C2.85501 38.5728 2.58056 38.9409 2.39648 39.3225C4.39457 44.9653 9.39816 48.9247 14.8101 50.317C18.2707 51.1905 19.8839 51.2775 22.4677 52.0005C22.8058 52.3552 25.1887 54.9323 25.1887 54.9323V52.4623C25.1887 52.4623 23.6191 50.7621 23.3781 50.5345V50.5312Z",
    fill: "url(#paint2_linear_1187_138726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.6411 47.0371C19.7678 48.0846 22.4687 48.2051 24.2794 49.0786C24.2794 49.0786 24.9387 49.6811 25.1864 49.9589C25.4374 49.6811 26.0967 49.0786 26.0967 49.0786C27.9074 48.2051 30.6083 48.0846 34.735 47.0371C39.9461 45.715 45.5655 41.1231 45.5655 33.9072C45.5655 28.7464 42.6035 26.852 42.6035 20.2988C42.6035 15.8809 44.2736 12.4772 44.2736 12.4772C44.2736 12.4772 40.4214 11.6973 38.6274 6.82094C38.6274 6.82094 36.0704 9.20726 32.5428 9.20726C28.1216 9.20726 25.1864 6.10471 25.1864 6.10471C25.1864 6.10471 22.2511 9.20726 17.8333 9.20726C14.3056 9.20726 11.7486 6.82094 11.7486 6.82094C9.9547 11.6973 6.10244 12.4772 6.10244 12.4772C6.10244 12.4772 7.77254 15.8809 7.77254 20.2988C7.77254 26.852 4.81055 28.7464 4.81055 33.9072C4.81055 41.1231 10.4333 45.715 15.6444 47.0371H15.6411ZM43.6779 33.9072C43.6779 40.0287 38.8015 44.0516 34.2698 45.203C30.9999 46.0363 27.0004 46.4647 25.7921 47.1508C25.521 47.3517 25.1864 47.7031 25.1864 47.7031C25.1864 47.7031 24.855 47.3483 24.5806 47.1508C23.3723 46.4647 19.3728 46.0363 16.1029 45.203C15.9791 45.1728 15.8553 45.1394 15.7314 45.1026L41.4555 25.7844C42.3324 28.8501 43.6712 30.8582 43.6712 33.9072H43.6779ZM41.8471 13.5114C41.325 15.0777 40.7159 17.4975 40.7159 20.2988C40.7159 21.4602 40.7996 22.491 40.9435 23.4215L13.3417 44.1487C9.88442 42.3715 6.85549 38.961 6.70488 34.2754L38.4266 10.459C39.5344 11.9952 40.8029 12.9424 41.8438 13.5147L41.8471 13.5114ZM9.66352 20.3022C9.66352 17.5008 9.05439 15.0777 8.53228 13.5147C9.7472 12.8487 11.2767 11.6672 12.4916 9.63566C13.8003 10.3686 15.6544 11.1049 17.8333 11.1049C21.1333 11.1049 23.7137 9.66244 25.1864 8.5814C26.6623 9.66579 29.2394 11.1049 32.5428 11.1049C33.0683 11.1049 33.577 11.0614 34.0623 10.9845L7.03957 31.2766C7.81939 28.2242 9.66018 25.694 9.66018 20.2988L9.66352 20.3022Z",
    fill: "url(#paint3_linear_1187_138726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M17.8368 7.52045C22.2714 7.52045 25.1899 3.74851 25.1899 3.74851V1.38896L22.8672 3.68492C21.6723 4.86637 19.7646 5.83027 17.8335 5.83027C16.3943 5.83027 15.0355 5.18767 13.8507 4.20704L10.2461 1.22162L10.9958 4.02296C10.9958 4.02296 14.3895 7.52045 17.8335 7.52045H17.8368Z",
    fill: "url(#paint4_linear_1187_138726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M47.7876 33.9106C47.7876 41.7423 42.1916 46.8965 35.1531 48.677C31.4448 49.6142 28.8844 49.8551 27.0001 50.5312C26.7591 50.7588 25.1895 52.459 25.1895 52.459V54.929C25.1895 54.929 27.5758 52.3519 27.9105 51.9971C30.4909 51.2776 32.1041 51.1905 35.5681 50.3137C42.5731 48.5097 48.8988 42.405 48.8988 33.9072C48.8988 30.8482 48.2093 28.984 47.4964 27.1967L46.2581 27.2369C47.0546 29.1681 47.7842 31.2532 47.7842 33.9072L47.7876 33.9106Z",
    fill: "url(#paint5_linear_1187_138726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M32.5473 7.52045C35.9879 7.52045 39.3816 4.02296 39.3816 4.02296L40.1313 1.22162L36.5267 4.20704C35.3386 5.19102 33.9831 5.83027 32.5439 5.83027C30.6128 5.83027 28.7051 4.86637 27.5102 3.68492L25.1875 1.38896V3.74851C25.1875 3.74851 28.106 7.52045 32.5439 7.52045H32.5473Z",
    fill: "url(#paint6_linear_1187_138726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M10.9976 4.02296L10.2479 1.22162L8.63137 5.64954C7.93522 7.55726 6.7705 8.76549 5.17404 9.23405L1.50586 10.3151L3.80517 11.3961C3.80517 11.3961 9.46474 10.9008 11.001 4.01961L10.9976 4.02296Z",
    fill: "url(#paint7_linear_1187_138726)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M3.71301 20.3122C3.71301 26.1291 0.747669 27.4511 0.747669 33.9072C0.747669 43.2116 7.94346 49.2995 14.6272 51.0198C18.0042 51.8432 19.025 51.8967 22.0773 52.6498C22.3284 52.9175 25.1899 56 25.1899 56C25.1899 56 28.0515 52.9175 28.3025 52.6498C31.3515 51.9001 32.3723 51.8432 35.7527 51.0198C42.4364 49.2995 49.6322 43.2116 49.6322 33.9072C49.6322 27.4511 46.6669 26.1257 46.6669 20.3122C46.6669 18.2137 47.112 16.1387 47.9855 14.154L49.8799 9.85322L45.4118 8.53789C44.0496 8.13627 43.0489 7.07865 42.4364 5.40186L40.4618 0L36.0606 3.64475C34.8925 4.612 33.7111 5.10065 32.5464 5.10065C30.9867 5.10065 29.2129 4.34425 28.0281 3.1695L25.1933 0.36481L22.3585 3.1695C21.1737 4.34425 19.3965 5.10065 17.8402 5.10065C16.6721 5.10065 15.4907 4.612 14.3226 3.64475L9.91477 0L7.94011 5.40186C7.32764 7.07865 6.32692 8.13292 4.96139 8.53789L0.5 9.85322L2.39433 14.154C3.26787 16.1387 3.71301 18.2137 3.71301 20.3122ZM5.17224 9.23404C6.76871 8.76213 7.93007 7.55726 8.62957 5.64953L10.2461 1.22161L13.8507 4.20703C15.0355 5.19101 16.391 5.83027 17.8335 5.83027C19.7613 5.83027 21.6724 4.86636 22.8672 3.68492L25.1899 1.38896L27.5127 3.68492C28.7075 4.86636 30.6152 5.83027 32.5464 5.83027C33.9855 5.83027 35.341 5.18766 36.5292 4.20703L40.1338 1.22161L41.7503 5.64953C42.4464 7.55726 43.6112 8.76548 45.2076 9.23404L48.8758 10.3151L47.3162 13.8561C46.5296 15.64 45.9339 17.8322 45.9339 20.3089C45.9339 23.4415 46.7305 25.2756 47.4969 27.1934C48.2098 28.9806 48.8992 30.8449 48.8992 33.9039C48.8992 42.4016 42.5703 48.5063 35.5686 50.3103C32.1046 51.1838 30.4914 51.2709 27.9109 51.9938C27.5729 52.3486 25.1899 54.9257 25.1899 54.9257C25.1899 54.9257 22.8036 52.3486 22.4689 51.9938C19.8885 51.2742 18.2753 51.1872 14.8113 50.3103C9.39935 48.918 4.39577 44.962 2.39768 39.3158C1.80528 37.6491 1.47729 35.8384 1.47729 33.9039C1.47729 27.5582 4.44262 26.3567 4.44262 20.3089C4.44262 17.8322 3.84688 15.64 3.06036 13.8561L1.50072 10.3151L5.1689 9.23404H5.17224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M15.7383 45.1026C15.8621 45.1394 15.986 45.1729 16.1098 45.203C19.3797 46.0364 23.3759 46.4648 24.5874 47.1509C24.8585 47.3517 25.1932 47.7031 25.1932 47.7031C25.1932 47.7031 25.5246 47.3483 25.799 47.1509C27.0072 46.4648 31.0067 46.0364 34.2766 45.203C38.8083 44.0517 43.6847 40.0287 43.6847 33.9073C43.6847 30.8583 42.346 28.8501 41.4691 25.7844L15.745 45.1026H15.7383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M7.04102 31.2766L34.0637 10.9845C33.5784 11.0614 33.0697 11.1049 32.5442 11.1049C29.2409 11.1049 26.6638 9.66243 25.1878 8.58139C23.7118 9.66578 21.1347 11.1049 17.8347 11.1049C15.6559 11.1049 13.8017 10.3686 12.4931 9.63566C11.2748 11.6672 9.74864 12.8487 8.53372 13.5147C9.05584 15.081 9.66497 17.5008 9.66497 20.3022C9.66497 25.6973 7.82084 28.2242 7.04436 31.2799L7.04102 31.2766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M13.3458 44.152L40.9476 23.4248C40.8037 22.4944 40.72 21.4635 40.72 20.3022C40.72 17.5008 41.3258 15.0777 41.8512 13.5147C40.807 12.9424 39.5385 11.9952 38.4341 10.459L6.70898 34.2787C6.85959 38.9644 9.88517 42.3748 13.3458 44.152ZM34.545 15.4793V23.4114L38.7453 20.2587C38.7453 20.2587 38.6048 21.2728 38.7453 22.9763L32.1587 27.923V19.3751C32.1587 18.1669 31.0073 18.1367 31.0073 18.1367L34.545 15.4793ZM25.2875 22.4308V26.3667L27.9081 24.3987V20.4628L30.1807 18.7559V29.409L27.9081 31.1159V27.2202L25.2875 29.1881V33.0839L22.9012 34.8745V26.3299C22.9012 25.1217 21.7499 25.0882 21.7499 25.0882L25.2875 22.4308ZM15.528 29.7604L18.49 34.2988V27.5348L20.8127 25.791V36.4408L18.3595 38.2816L15.7121 34.2285V40.2696L13.3894 42.0134V33.4654C13.3894 32.2572 12.238 32.2271 12.238 32.2271L15.528 29.7571V29.7604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M6.0195 22.0693C5.53086 26.8888 3.14453 28.8233 3.14453 33.9106C3.14453 40.1525 7.42184 46.7024 15.2268 48.677C18.9351 49.6142 21.4955 49.8551 23.3798 50.5312C23.6207 50.7588 25.1904 52.459 25.1904 52.459C25.1904 52.459 26.7568 50.7588 27.0011 50.5312C28.8854 49.8518 31.4458 49.6142 35.1541 48.677C42.959 46.7024 47.2363 40.1525 47.2363 33.9106C47.2363 28.2443 44.2743 26.4939 44.2743 20.3022C44.2743 15.476 46.577 11.3995 46.577 11.3995C46.577 11.3995 40.9174 10.9041 39.3812 4.02295C39.3812 4.02295 35.9875 7.52044 32.5469 7.52044C28.1123 7.52044 25.1904 3.7485 25.1904 3.7485C25.1904 3.7485 22.272 7.52044 17.8373 7.52044C14.3934 7.52044 10.9997 4.02295 10.9997 4.02295C9.46679 10.9041 3.80387 11.3995 3.80387 11.3995C3.80387 11.3995 6.10652 15.476 6.10652 20.3022C6.10652 20.9347 6.07305 21.5204 6.0195 22.0693ZM6.10317 12.4805C6.10317 12.4805 9.95543 11.7007 11.7494 6.82429C11.7494 6.82429 14.3064 9.21061 17.834 9.21061C22.2519 9.21061 25.1871 6.10806 25.1871 6.10806C25.1871 6.10806 28.1223 9.21061 32.5435 9.21061C36.0711 9.21061 38.6282 6.82429 38.6282 6.82429C40.4221 11.7007 44.2743 12.4805 44.2743 12.4805C44.2743 12.4805 42.6043 15.8843 42.6043 20.3022C42.6043 26.8554 45.5662 28.7497 45.5662 33.9106C45.5662 41.1265 39.9468 45.7184 34.7357 47.0404C30.609 48.088 27.9081 48.2085 26.0974 49.082C26.0974 49.082 25.4381 49.6844 25.1871 49.9622C24.9394 49.6844 24.2801 49.082 24.2801 49.082C22.4661 48.2085 19.7685 48.088 15.6418 47.0404C10.4307 45.7184 4.80793 41.1265 4.80793 33.9106C4.80793 28.7497 7.76992 26.8554 7.76992 20.3022C7.76992 15.8843 6.09983 12.4805 6.09983 12.4805H6.10317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M43.043 50.5647C43.043 51.6189 43.8998 52.4724 44.954 52.4724C46.0083 52.4724 46.8618 51.6156 46.8618 50.5647C46.8618 49.5138 46.0083 48.657 44.954 48.657C43.8998 48.657 43.043 49.5104 43.043 50.5647ZM46.4501 50.5647C46.4501 51.3947 45.7807 52.0641 44.9507 52.0641C44.1207 52.0641 43.4513 51.3947 43.4513 50.5647C43.4513 49.7346 44.1207 49.0653 44.9507 49.0653C45.7807 49.0653 46.4501 49.7346 46.4501 50.5647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M44.1655 51.6524H44.5738V50.7688H44.8683L45.28 51.6524H45.7318L45.3 50.7287C45.5511 50.6383 45.7318 50.4007 45.7318 50.1195C45.7318 49.7614 45.4406 49.4736 45.0825 49.4736H44.1621V51.6524H44.1655ZM44.5738 49.8819H45.0858C45.2164 49.8819 45.3235 49.989 45.3235 50.1195C45.3235 50.25 45.2164 50.3571 45.0858 50.3571H44.5738V49.8819Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1187_138726",
    x1: 19.8763,
    y1: 41.9526,
    x2: 25.9179,
    y2: 41.9526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C4CACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#909AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1187_138726",
    x1: 46.5727,
    y1: 27.2369,
    x2: 46.5727,
    y2: 10.3184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#7C888F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1187_138726",
    x1: 2.39648,
    y1: 46.6086,
    x2: 25.1887,
    y2: 46.6086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D1D5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#AEB5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#828D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1187_138726",
    x1: 38.7111,
    y1: 45.4573,
    x2: 11.6917,
    y2: 6.86779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C888F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#859097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#AEB5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C7CBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D1D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D1D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C9CCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#90999F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1187_138726",
    x1: 10.2461,
    y1: 4.37103,
    x2: 25.1899,
    y2: 4.37103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#EAECED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D1D5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#AEB5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#828D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1187_138726",
    x1: 25.1895,
    y1: 41.0629,
    x2: 48.8988,
    y2: 41.0629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D6DADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B7BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#8F9A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1187_138726",
    x1: 25.1908,
    y1: 4.37103,
    x2: 40.1347,
    y2: 4.37103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#EAECED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D1D5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#AEB5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#828D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1187_138726",
    x1: 1.50251,
    y1: 6.31222,
    x2: 10.9976,
    y2: 6.31222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EAECED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D1D5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#AEB5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#828D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1187_138726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.3799,
    height: 56,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhlShield);
export default __webpack_public_path__ + "static/media/nhl-shield.bb2c11feed2b27624412a6ad7113e495.svg";
export { ForwardRef as ReactComponent };